import amplitude from 'amplitude-js'

import api from 'lib/api_client'

export default class Eventer {
  constructor (args) {
    const {
      metaProfile = {},
      serverEvents = [],
      amplitudeApiKey
    } = args
    this.metaProfile = metaProfile
    this.serverEvents = serverEvents
    this.amplitudeApiKey = amplitudeApiKey

    this.setupAmplitude().then(() => {
      this.serverEvents.forEach(({ kind, context }) => this.logJs({ kind, ...context }))
    })
  }

  setupAmplitude = async () => {
    this.amp = amplitude.getInstance()
    this.amp.init(this.amplitudeApiKey)
    this.amp.setUserProperties(this.metaProfile)
    this.amp.setUserId(this.metaProfile.id)
  }

  log = (kind, context = {}, eventableType = null, eventableId = null) => {
    const event = { occurredAt: new Date(), context, kind, accountRoleId: this.metaProfile.id }
    this.logJs(event)

    event.accountRoleId = this.metaProfile.accountRoleId
    return this.logToServer({ ...event, eventableType, eventableId })
  }

  logJs = event => {
    const { kind, ...context } = event
    switch (kind) {
      case 'created_account':
        global.fbq('track', 'CompleteRegistration', { value: 1.50, currency: 'USD' })
    }
    this.amp.logEvent(kind, context)
  }

  logToServer = async event => {
    await api.createEvent(event)
  }
}
